import { Button, Modal, Typography } from "@mui/material";
import { FC, useState } from "react";
import { StyledModalDiv } from "../../../../util/accordianStyles";
import getModalStyle from "../../../../util/getModalStyle";

interface RecalculatingWarningModalProps {
  open: boolean;
  handleClose: () => void;
}

const RecalculatingWarningModal: FC<RecalculatingWarningModalProps> = ({
  open,
  handleClose,
}) => {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const body = (
    <StyledModalDiv style={{ ...modalStyle, width: 500 }}>
      <Typography variant="h6" style={{ fontWeight: "bold" }}>
        Please wait for recalculation to complete before generating full details.
      </Typography>

      <div
        style={{ display: "flex", justifyContent: "center", paddingTop: 30 }}
      >
        <Button onClick={handleClose} variant="contained" color="primary">
          OK
        </Button>
      </div>
    </StyledModalDiv>
  );

  return (
    <Modal open={open} onClose={handleClose}>
      {body}
    </Modal>
  );
};

export default RecalculatingWarningModal;
